import React from 'react';
import ClassAssembly5D from 'views/ClassAssembly5D';

const ClassAssembly5DPage = () => {
    return <ClassAssembly5D/>;
  };
  
  export default ClassAssembly5DPage;
  //5D